// ============================================================================
// defaultAvatar - DiceBear fallback for users without an uploaded photo
// ============================================================================
// Renders a deterministic cartoon avatar based on the user's UID so every
// player gets a consistent identity at the table without anyone having to
// upload anything. Used by PremiumThemedTableSVG, ProfileAvatar, and any
// other surface that renders a user thumbnail.
//
// Style cycles based on a hash of the UID so the lobby has visual variety
// without the user picking a style. They can always override by selecting
// from the AvatarSelector (which uses the same DiceBear API).
// ============================================================================

const DICEBEAR_FALLBACK_STYLES = [
  'adventurer',     // cartoon adventurer
  'avataaars',      // Notion-style
  'big-ears',       // cute critters
  'fun-emoji',      // expressive
  'lorelei',        // elegant
  'micah',          // simple cartoon
  'open-peeps',     // hand-drawn
  'personas',       // character personas
];

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/**
 * Returns a DiceBear avatar URL for a given seed (typically a UID). The
 * style is picked deterministically from the seed so the same UID always
 * renders the same avatar, but different UIDs get different cartoon
 * styles for lobby variety.
 */
export function getDefaultAvatarUrl(seed: string | undefined | null, size = 200): string {
  const safeSeed = (seed && seed.length > 0) ? seed : 'guest';
  const style = DICEBEAR_FALLBACK_STYLES[hashString(safeSeed) % DICEBEAR_FALLBACK_STYLES.length];
  const params = new URLSearchParams({
    seed: safeSeed,
    backgroundColor: 'transparent',
    size: size.toString(),
  });
  return `https://api.dicebear.com/7.x/${style}/svg?${params.toString()}`;
}
